import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Card, InputAdornment, Stack, Typography, IconButton, Box, Alert } from '@mui/material';
import Iconify from '../../reusable-components/iconify';
import { MinimalLogo } from '../../reusable-components/logo';
import FormProvider, { RHFTextField } from '../../reusable-components/hook-form';
import { NEW_PASSWORD_SCHEMA } from '../../reusable-components/form/authSchema';
import { AwaitButton } from '../../reusable-components/await-button';

export default function NewPassword() {
  const [showPassword, setShowPassword] = useState(false);
  const methods = useForm({
    resolver: yupResolver(NEW_PASSWORD_SCHEMA),
  });
  const {
    reset,
    setError,
    handleSubmit,
    formState: { errors, isSubmitting, isSubmitSuccessful },
  } = methods;

  const onSubmit = async (data) => {
    try {
      // await login(data.password, );
    } catch (error) {
      console.error(error);
      reset();
      setError('afterSubmit', {
        ...error,
        message: error.message,
      });
    }
  };
  return (
    <Card sx={{ m: 3, p: 3 }}>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={3}>
          {!!errors.afterSubmit && <Alert severity="error">{errors.afterSubmit.message}</Alert>}
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: -13 }}>
            <MinimalLogo disabledLink />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Typography variant="h3" color="primary">
              New Password
            </Typography>
          </Box>
          <Box>
            <Typography variant="subtitle1" sx={{ mb: 0.5 }}>
              Password
            </Typography>

            {/* <RHFTextField
            name="password"
            type={showPassword ? 'text' : 'password'}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Iconify icon="eva:lock-outline"  />
                  {!password && (
                    <Typography variant="subtitle2"  sx={{ ml: 2 }}>
                      Password
                    </Typography>
                  )}
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleClickShowPassword}>
                    <Iconify icon={showPassword ? 'mdi:eye' : 'mdi:eye-off'}  />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          /> */}
            <RHFTextField
              name="password"
              placeholder="Minimum 8 characters"
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Iconify icon="eva:lock-outline" />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                      <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Box>
            <Typography variant="subtitle1" sx={{ mb: 0.5 }}>
              Confirm
            </Typography>

            <RHFTextField
              name="confirmPassword"
              placeholder="Confirm your password"
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Iconify icon="eva:lock-outline" />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                      <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          <AwaitButton
            fullWidth
            color="primary"
            size="large"
            type="submit"
            variant="contained"
            loading={isSubmitSuccessful || isSubmitting}
          >
            Submit
          </AwaitButton>
        </Stack>
      </FormProvider>
    </Card>
  );
}
